var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { EventCard } from "../../../components";
import * as RenderMethods from "./RenderMethods";
import { marketColumnsDisplay } from "../../../../../constants";
import { ContainerQuery } from "react-container-query";
import { observer } from "mobx-react";
var ContainerQueryObserver = observer(ContainerQuery);
var Multiview = /** @class */ (function (_super) {
    __extends(Multiview, _super);
    function Multiview(props) {
        var _this = _super.call(this, props) || this;
        _this.renderEventCardDetails = RenderMethods.renderEventCardDetailsMultiview;
        _this.renderMarkets = RenderMethods.renderMarketsMultiview;
        _this.renderBetButtons = RenderMethods.renderBetButtonsMultiview;
        _this.cardTypeClass = "rj-ev-list__" + _this.componentPrefix + "--multiview";
        _this.buttonsHolderClass = "rj-ev-list__" + _this.componentPrefix + "__buttons-holder--multiview";
        return _this;
    }
    Multiview.prototype.render = function () {
        var _this = this;
        return (React.createElement(ContainerQueryObserver, { query: marketColumnsDisplay }, function (params) { return (React.createElement("div", { className: _this.setClasses(), "data-uat": "div-ev-list-" + _this.componentPrefix },
            React.createElement("div", { className: "rj-ev-list__" + _this.componentPrefix + "__inner", "data-uat": "div-ev-list-" + _this.componentPrefix + "-inner" },
                _this.renderEventCardDetails(_this.getCardDetailsParams(_this.props), _this.componentPrefix),
                _this.renderMarkets(_this.props, _this.buttonsHolderClass, _this.componentPrefix, params),
                _this.renderMarketsCountLink(_this.getCountLinkParams(_this.props), _this.componentPrefix)))); }));
    };
    return Multiview;
}(EventCard));
export { Multiview };
//# sourceMappingURL=Multiview.js.map